import { createApp } from "vue";
import { plugin, defaultConfig } from "@formkit/vue";
import { createMultiStepPlugin } from "@formkit/addons";
import App from "./App.vue";
import "@formkit/addons/css/multistep";
import "@formkit/themes/genesis";
import { createPinia } from "pinia";
import router from "./Router";
import  createPersistedState  from "pinia-plugin-persistedstate";
import VueApexCharts from "vue3-apexcharts";

const pinia = createPinia();
pinia.use(createPersistedState);

import { OhVueIcon, addIcons } from "oh-vue-icons";
import { MdKeyboardarrowdownRound, MdKeyboardarrowupRound } from "oh-vue-icons/icons";
import { IoHome } from "oh-vue-icons/icons";
import { BiBarChartSteps, IoExitOutline, BiTrash, BiPlusSquare, IoClose,  } from "oh-vue-icons/icons";


addIcons(MdKeyboardarrowdownRound, MdKeyboardarrowupRound, IoHome, BiBarChartSteps, IoExitOutline, BiTrash, BiPlusSquare, IoClose );

const app = createApp(App);




app.use(
  plugin,
  defaultConfig({
    plugins: [createMultiStepPlugin()],
  })
);
 
app.use(VueApexCharts);
app.use(pinia);
app.use(router)
//

app.component('v-icon', OhVueIcon);

app.mount("#app");


